export default () => ({
  categories: {}
});
